import React from 'react'
import { EditableComponent } from '@adobe/aem-react-editable-components'
import { Video as UIFoundationsVideo } from '@dcxwam/dcx-wam-ui-foundations'
import { EditableComponentPropsType } from '../../../utils/prop-types'
import withComponentRefresh from '../../../utils/aem/editor/withComponentRefresh'
import { useExtractEditableProps } from '../../../utils/aem/editor/extractEditableProps'
import { VideoModelProps } from './types'
import VideoEditConfig from './VideoEditConfig'
import {
  withErrorBoundary,
  ErrorFallback
} from '../../functional/ErrorBoundary'

const Video = withComponentRefresh(
  (props: EditableComponentPropsType<VideoModelProps>) => {
    const {
      title,
      portraitVideoUrl,
      portraitPosterUrl,
      landscapeVideoUrl,
      landscapePosterUrl,
      autoPlay,
      loop,
      playControls,
      audioControls,
      playAriaLabel,
      pauseAriaLabel,
      muteAriaLabel,
      unmuteAriaLabel,
      videoDescription,
      trackPath,
      trackKind,
      id,
      cqType,
      ...rest
    } = props.model

    const editableProps = useExtractEditableProps(props, rest)

    const videoProps = {
      title,
      portraitSrc: portraitVideoUrl,
      portraitPoster: portraitPosterUrl,
      landscapeSrc: landscapeVideoUrl,
      landscapePoster: landscapePosterUrl,
      autoPlay,
      loop,
      playControls,
      audioControls,
      playAriaLabel,
      pauseAriaLabel,
      muteAriaLabel,
      unmuteAriaLabel,
      videoDescription,
      track: trackPath,
      trackKind,
      id
    }

    return (
      <EditableComponent {...editableProps}>
        {VideoEditConfig.isEmpty(props.model) ? (
          VideoEditConfig.emptyLabel
        ) : (
          <UIFoundationsVideo {...videoProps} />
        )}
      </EditableComponent>
    )
  }
)

const VideoWithErrorBoundary = withErrorBoundary(Video, {
  componentName: 'Video',
  fallback: <ErrorFallback componentName="Video" />
})

export default VideoWithErrorBoundary
